/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Section_FaqInputs */

const en_directory_detail_section_faq = /** @type {(inputs: Directory_Detail_Section_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

const zh_directory_detail_section_faq = /** @type {(inputs: Directory_Detail_Section_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常见问题`)
};

/**
* | output |
* | --- |
* | "FAQ" |
*
* @param {Directory_Detail_Section_FaqInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_section_faq = /** @type {((inputs?: Directory_Detail_Section_FaqInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Section_FaqInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_section_faq(inputs)
	return zh_directory_detail_section_faq(inputs)
});
export { directory_detail_section_faq as "directory.detail.section.faq" }